
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Portal","transform":"translate(-684 -553)"}},[_c('g',{attrs:{"id":"Group_23323","data-name":"Group 23323","transform":"translate(684 553)","fill":"#777a8d"}},[_c('path',{attrs:{"id":"Path_20059","data-name":"Path 20059","d":"M1.25 6.875h6.875a1.25 1.25 0 001.25-1.25V1.25A1.25 1.25 0 008.125 0H1.25A1.25 1.25 0 000 1.25v4.375a1.25 1.25 0 001.25 1.25zm0-5.625h6.875v4.375H1.25z"}}),_c('path',{attrs:{"id":"Path_20060","data-name":"Path 20060","d":"M20.125 0H18.25A1.25 1.25 0 0017 1.25v4.375a1.25 1.25 0 001.25 1.25h1.875a1.25 1.25 0 001.25-1.25V1.25A1.25 1.25 0 0020.125 0zm0 5.625H18.25V1.25h1.875z","transform":"translate(-6.375)"}}),_c('path',{attrs:{"id":"Path_20061","data-name":"Path 20061","d":"M3.125 13H1.25A1.25 1.25 0 000 14.25v4.375a1.25 1.25 0 001.25 1.25h1.875a1.25 1.25 0 001.25-1.25V14.25A1.25 1.25 0 003.125 13zm0 5.625H1.25V14.25h1.875z","transform":"translate(0 -4.875)"}}),_c('path',{attrs:{"id":"Path_20062","data-name":"Path 20062","d":"M17.125 13H10.25A1.25 1.25 0 009 14.25v4.375a1.25 1.25 0 001.25 1.25h6.875a1.25 1.25 0 001.25-1.25V14.25a1.25 1.25 0 00-1.25-1.25zm0 5.625H10.25V14.25h6.875z","transform":"translate(-3.375 -4.875)"}})])])])
          )
        }
      }
    